import { useLanguageAwareRouting } from '@gofranz/common-components';
import type { HttpNewForm } from '@gofranz/formshive-common';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CreateForm } from '../../../components/Form/Create';
import { dumpFormSpecToToml } from '../../../lib/form-specs';
import { FORM_TEMPLATES, type FormTemplate } from '../../../lib/form-templates';
import { useRustyState } from '../../../state';

export function AccountFormCreatePage() {
  const { api } = useRustyState.getState();
  const nav = useNavigate();
  const { createLanguageURL } = useLanguageAwareRouting();
  const [searchParams, setSearchParams] = useSearchParams();

  const templateId = searchParams.get('template');
  const template: FormTemplate | undefined = templateId
    ? FORM_TEMPLATES.find((tpl) => tpl.id === templateId)
    : undefined;

  const setTemplateId = (id: string | null) => {
    const next = new URLSearchParams(searchParams);
    if (id) {
      next.set('template', id);
    } else {
      next.delete('template');
    }
    setSearchParams(next, { replace: true });
  };

  const submit = async (newForm: HttpNewForm) => {
    const form = await api.newForm(newForm);
    if (template) {
      await api.updateForm(form.id, {
        title: newForm.title,
        filter_spam: newForm.filter_spam ?? false,
        check_challenge: newForm.check_challenge ?? false,
        check_specs: true,
        specs: dumpFormSpecToToml(template.spec),
        auto_response_enabled: newForm.auto_response_enabled ?? false,
        redirect_url: newForm.redirect_url,
        retention_days: newForm.retention_days,
      });
    }
    nav(createLanguageURL(`/account/forms/${form.id}`));
  };

  return <CreateForm submitFormCb={submit} template={template} onTemplateChange={setTemplateId} />;
}
